import { useCallback, useEffect, useState } from "react";
import { getAsset } from '../../../../services/general';
import { Button, Col, Row, message } from "antd";
import config from "../../../../config";
import { io } from "socket.io-client";
import NormalForm from "./NormalForm";
import {
  getRxViewerUrl,
} from "../../../../services/rx";

const RxForm = ({
  form,
  inputs,
  disableForm,
  admissionPatientExamId,
  roles,
  status,
  setRefresh,
  removeDocument,
  convertFile,
  convertError,
  isDICOM,
  handleConvertFile,
  imageUrl,
  setImageUrl,
  fileList,
  setFileList,
  loadingFiles,
  countrySettings,
  fromExternal,
}) => {
  const [enableView, setEnableView] = useState(false);
  const [useEdx, setUseEdx] = useState(false);
  const [procedureId, setProcedureId] = useState(null);
  const [socket, setSocket] = useState();

  const getUrl = async (file) => {
    let url;
    try {
      if (file.uid === '-1') {
        const { document_url } = await getAsset({
          field: file.field,
          id: file.id,
          type: file.document_type,
        });
        url = document_url;
      } else {
        const blob = new Blob([file], { type: file.type });
        url = window.URL.createObjectURL(blob);
      }
    } catch (error) {
      console.error(error);
      message.error({
        content: `Error al obtener url del archivo: ${error}`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    }
    return url;
  };

  const handleDicomPreview = async () => {
    console.info('useEdx: ', useEdx)
    if (useEdx) {
      const response = await getRxViewerUrl({ admissionPatientExamId });

      if (response?.status === 200) {
        window.open(response.data?.viewerUrl, "_blank", "noopener,noreferrer");
      }
    } else {
      const [file] = fileList[procedureId];
      const newWindow = window.open(`${config.dicomUrl}?url=${await getUrl(file)}`, '_blank', 'noopener,noreferrer')
      if (newWindow) {
        newWindow.opener = null;
      }
    }
  };

  const checkViewerStatus = useCallback(async () => {
    inputs.procedures.map(procedure => {
      if (procedure.input_type === 'uid' && procedure.result_id) {
        if (procedureId === null || procedureId === undefined) {
          setProcedureId(procedure.id);
          setUseEdx(true);
        }
        setEnableView(true);
      }
      if (procedure.document_file_name !== null && procedure.code === 'DOCUMENT_XRAY_DCM' && procedure.result_id) {
        if (procedureId === null || procedureId === undefined) {
          setProcedureId(procedure.id);
        }
        setEnableView(true);
      }
      return true;
    });
  }, [inputs]);

  useEffect(() => {
    checkViewerStatus();
  }, [checkViewerStatus,]);

  const initSocket = () => {
    const socket = io(config.socketServer);
    setSocket(socket);
  }

  useEffect(() => {
    return () => {
      if (socket) {
        socket.disconnect();
      }
    }
  }, [socket]);

  useEffect(() => {
    initSocket();
  }, []);

  useEffect(() => {
    if (socket) {
      if (inputs?.procedures?.length && admissionPatientExamId) {
        const socketType = `rx-${admissionPatientExamId}`;
        socket.on(socketType, (data) => {
          if (data) {
            setRefresh(Date.now());
            window.location.reload();
          }
        });

      }
    }
  }, [socket, inputs, admissionPatientExamId, setRefresh])

  return (
    <Row justify="">
      {
        <Col>
          <Button
            onClick={handleDicomPreview}
            className="cmt-button primary mb-lg-20 mb-xs-0"
            type="primary"
            size="large"
            disabled={!enableView}
          >
            Visualizar Rx
          </Button>
        </Col>
      }
      <Col lg={24}>
        <NormalForm
          form={form}
          inputs={inputs}
          disableForm={disableForm}
          roles={roles}
          status={status}
          removeDocument={removeDocument}
          convertFile={convertFile}
          convertError={convertError}
          isDICOM={isDICOM}
          handleConvertFile={handleConvertFile}
          imageUrl={imageUrl}
          setImageUrl={setImageUrl}
          fileList={fileList}
          setFileList={setFileList}
          loadingFiles={loadingFiles}
          countrySettings={countrySettings}
          fromExternal={fromExternal}
        />
      </Col>
    </Row>
  )
}

export default RxForm;